// Common materials and EU Critical Raw Materials (subset) for dropdowns and flags
// Source references: EU Critical Raw Materials Act (2023/2024 updates), general industry lists

export const COMMON_MATERIALS = [
  'Aluminum','Steel','Stainless Steel','Copper','Iron','Nickel','Zinc','Lead','Tin','Magnesium',
  'Lithium','Cobalt','Manganese','Graphite','Silicon','Chromium','Titanium','Tungsten','Molybdenum',
  'Gold','Silver','Platinum','Palladium','Rare Earths','Neodymium','Praseodymium','Dysprosium','Terbium',
  'Plastic','ABS','Polycarbonate','PVC','HDPE','LDPE','PP','PET','Rubber','Glass','Ceramic',
  'Carbon Fiber','Epoxy Resin','Composite','Brass','Bronze'
];

// Minimal critical list for flagging; extend as needed
export const CRITICAL_MATERIALS = new Set([
  'Lithium','Cobalt','Nickel','Graphite','Rare Earths','Neodymium','Praseodymium','Dysprosium','Terbium',
  'Magnesium','Manganese','Platinum','Palladium','Silicon','Tungsten','Titanium'
]);

export const MATERIAL_ALIASES = {
  'Aluminium': 'Aluminum',
  'Cu': 'Copper',
  'Fe': 'Iron',
  'Au': 'Gold',
  'Ag': 'Silver',
  'Pt': 'Platinum',
  'Pd': 'Palladium',
  'PVC': 'PVC',
  'PC': 'Polycarbonate',
  'PP': 'PP',
  'PETE': 'PET'
};

export const normalizeMaterialName = (name) => {
  if (!name) return '';
  const n = String(name).trim();
  return MATERIAL_ALIASES[n] || n;
};
